import { useEffect, useState } from "react";
import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";

export default function TRAAvatar({ label, src, size = 40, className, ...rest }) {
  const initials = String(label || "?")
    .trim()
    .slice(0, 1)
    .toUpperCase();
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    setBroken(false);
  }, [src]);
  const showImage = Boolean(src) && !String(src).startsWith("data:image/svg") && !broken;
  return (
    <div
      className={cn(styles.avatar, className)}
      style={{
        width: size,
        height: size,
        fontFamily: "var(--tra-font-family-display)",
        fontWeight: 700,
        fontSize: size >= 48 ? "var(--tra-font-h3-size)" : "var(--tra-font-body-size)",
        background: "color-mix(in srgb, var(--tra-color-info) 18%, transparent)",
        border: "var(--tra-border-width-hairline) solid color-mix(in srgb, var(--tra-color-info) 40%, transparent)",
        color: "var(--tra-color-text-secondary)",
      }}
      role="img"
      aria-label={label}
      {...rest}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setBroken(true)}
          style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
        />
      ) : (
        initials
      )}
    </div>
  );
}
